// import * as React from "react";
import styled from "@emotion/styled";

import { Colors } from "../../Themes";

interface IStyledElements {
  open: boolean;
  children: any;
}

export const Wrapper = styled.div`
  top: 0;
  right: 0;
  z-index: 1;
  height: 70px;
  display: flex;
  position: fixed;
  padding: 0 40px;
  align-items: center;
  justify-content: flex-start;
  background-color: ${Colors.snow};
  box-shadow: 5px 1px 5px 1px rgba(0, 0, 0, 0.05);
  left: ${(props: IStyledElements) => (props.open ? "250px" : "60px")};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  & span {
    font-size: 1.45em;
    text-transform: capitalize;
    font-weight: 400;
    letter-spacing: 1px;
  }
`;

export const Avatar = styled.div`
  position: absolute;
  right: 40px;
  width: 50px;
  cursor: pointer;
  height: 50px;
  border-radius: 50%;
  background: #fff;
  box-shadow: rgba(84, 149, 248, 0.38) 0px 0px 0px 5px;
  border: 2px solid #fff;
  background-size: 50% !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
`;



// WEBPACK FOOTER //
// ./src/Components/Header/StyledElements.tsx